import React from 'react';
import { Bell } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../ui/button';

export const Header = ({ title, subtitle }) => {
    const { user } = useAuth();

    return (
        <header className="glass-header sticky top-0 z-40 h-[72px] px-8 flex items-center">
            <div className="flex items-center justify-between w-full">
                {/* Title */}
                <div>
                    <h1 className="text-2xl font-heading font-bold text-white">{title}</h1>
                    {subtitle && (
                        <p className="text-sm text-content-secondary mt-1">{subtitle}</p>
                    )}
                </div>

                {/* Actions */}
                <div className="flex items-center gap-4">
                    {/* Notifications */}
                    <Button 
                        variant="ghost" 
                        size="icon"
                        className="relative text-content-secondary hover:text-white"
                        data-testid="notifications-btn"
                    >
                        <Bell className="w-5 h-5" />
                        <span className="absolute top-1 right-1 w-2 h-2 bg-brand-red rounded-full" />
                    </Button>

                    {/* User Avatar */}
                    <div className="flex items-center gap-3 pl-4 border-l border-line-default">
                        <div className="w-9 h-9 rounded-full bg-brand-red/20 flex items-center justify-center">
                            <span className="text-brand-red font-bold text-sm">
                                {user?.name?.charAt(0) || 'U'}
                            </span>
                        </div>
                        <div className="hidden md:block">
                            <p className="text-sm font-medium text-white">{user?.name}</p>
                            <p className="text-xs text-content-muted capitalize">{user?.role}</p>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
